export default "__VITE_ASSET__CZHRyeBr__"